// removed by extract-text-webpack-plugin
module.exports = {"root":"Icon-module-root-3r_4i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/Icon.module.scss
// module id = 915
// module chunks = 0